import { render, staticRenderFns } from "./item.vue?vue&type=template&id=38c8d51f&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=38c8d51f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8d51f",
  null
  
)

export default component.exports